<template>
    <div class="ah-page oursourcing-page">
        <div class="page-header bottom-margin" id="oursourcing-page-header">
            <div class="ah-container ">
                <div class="title-row">
                    <div class="title">
                        <h1>委外管理</h1>
                    </div>
                    <div class="actions"></div>
                </div>
            </div>
        </div>
        <div class="ah-container">
            <div class="ah-panel">
                <div class="panel-body">
                    <el-tabs class="infos-tab" v-model="activeTabName" @tab-click="handleTypeChange">
                        <el-tab-pane label="委外廠商" name="vd">
                            <template slot="label">
                                <div class="name">委外廠商</div>
                                <div class="description">一般公司行號（開發票的廠商）</div>
                            </template>
                        </el-tab-pane>
                        <el-tab-pane label="委外勞務" name="os">
                            <template slot="label">
                                <div class="name">委外勞務</div>
                                <div class="description">個人或提供勞務服務的營業單位，例如：律師事務所 / 會計師事務所 / 商標事務所....</div>
                            </template>
                        </el-tab-pane>
                    </el-tabs>
                    <ahDataTable
                        tableKey="outsourcing-data-table"
                        :columns="tableColumns"
                        :data="datas"
                        :showRefreshButton="true"
                        :isRowClick="false"
                        v-loading="status == 'loading'"
                        @refresh="updateData"
                    >
                        <template v-slot:top-left-actions>
                            <el-select
                                v-model="cat_sno"
                                @change="updateData"
                                no-match-text="無匹配項目"
                                :filterable="true"
                                size="small"
                            >
                                <el-option :key="0" label="不限類型" :value="null" />
                                <el-option v-for="item in typeList" :key="item.sno" :label="item.catnam" :value="item.sno" />
                            </el-select>
                            <el-input
                                class="search"
                                :placeholder="activeTabName === 'vd' ? '搜尋名稱、證件號碼、統編、聯絡窗口姓名' : '搜尋名稱、證件號碼、統編'"
                                prefix-icon="el-icon-search"
                                v-model="searchTxt"
                                size="small"
                                @keydown.enter.native="handleSearchEnter"
                                clearable
                                @clear="handleSearchClear"
                                style="width: 300px;"
                            ></el-input>
                            <el-select
                                v-model="hasAdr"
                                size="small"
                                @change="updateData"
                            >
                                <el-option label="不限地址" :value="null" />
                                <el-option label="有地址" :value="true" />
                                <el-option label="無地址" :value="false" />
                            </el-select>
                        </template>
                        <template v-slot:top-right-actions>
                            <!-- <el-button size="small" icon="el-icon-upload2" @click="onUploadSheet">批次匯入</el-button> -->
                            <el-button v-if="activeTabName === 'vd' && !isQR()" size="small" icon="el-icon-upload2" @click="vendorImportDialogVisible = true">批次匯入</el-button>
                            <el-button v-if="activeTabName === 'os' && !isQR()" size="small" icon="el-icon-upload2" @click="personImportDialogVisible = true">批次匯入</el-button>
                            <el-button
                                v-if="activeTabName === 'vd' && !isQR()"
                                type="highlight"
                                size="small"
                                icon="el-icon-plus"
                                @click="handleAddVdBtnClick"
                            >新增委外廠商</el-button>
                            <el-button
                                v-if="activeTabName === 'os' && !isQR()"
                                type="highlight"
                                size="small"
                                icon="el-icon-plus"
                                @click="handleAddOsBtnClick"
                            >新增委外勞務</el-button>
                        </template>
                        <template v-slot:voo="scope">
                            <span class="idx clickable-col-text" @click="handleDataRowClick(scope.row)">{{ scope.row.voo }}</span>
                        </template>
                        <template v-slot:bsn="scope">
                            <div v-if="activeTabName === 'os'">{{ protectedInfo(scope.row.bsn, 'get', 4, false) }}</div>
                            <div v-else>{{ scope.row.bsn }}</div>
                        </template>
                        <template v-slot:fnam="scope">
                            <span type="text" class="strong clickable-col-text" @click="handleDataRowClick(scope.row)">{{ scope.row.fnam }}</span>
                        </template>
                        <template v-slot:adr="scope">
                            <div v-if="scope.row.adr">
                                <span v-if="scope.row.adR_CODE">{{ scope.row.adR_CODE }} </span>
                                <span v-if="scope.row.cty">{{ scope.row.cty }}</span>
                                <span>{{ scope.row.adr }}</span>
                                <span v-if="scope.row.ara"> {{ scope.row.ara }}</span>
                            </div>
                            <div v-else>（無）</div>
                        </template>
                    </ahDataTable>
                    <el-pagination
                        :small="isMobile()"
                        layout="prev, pager, next"
                        :page-size.sync="pageSize"
                        :total.sync="totalDataCount"
                        :current-page.sync="currPage"
                        @current-change="handlePaginationChange"
                        class="pagination"
                    >
                    </el-pagination>
                </div>
            </div>
        </div>
        <!-- <OutsourcingBatchImportDialog :visible="OutsourcingBatchImportDialog.visible" :data="OutsourcingBatchImportDialog.data" :type="activeTabName" @close="onOutsourcingBatchImportDialogClose" /> -->
        <OutsourcingVendorImportDialog :visible="vendorImportDialogVisible" @close="onVendorImportDialogClose" />
        <OutsourcingPersonImportDialog :visible="personImportDialogVisible" @close="onPersonImportDialogClose" />
    </div>
</template>
<script>
// import OutsourcingBatchImportDialog from '@/components/dashboard/Outsourcing/OutsourcingBatchImportDialog.vue';
import OutsourcingVendorImportDialog from '@/components/dashboard/Outsourcing/OutsourcingVendorImportDialog.vue';
import OutsourcingPersonImportDialog from '@/components/dashboard/Outsourcing/OutsourcingPersonImportDialog.vue';
import ahDataTable from '@/components/ui/ahDataTable.vue';

export default {
    name: 'OursourcingPage',
    components: { 
        // OutsourcingBatchImportDialog,
        OutsourcingVendorImportDialog,
        OutsourcingPersonImportDialog,
        ahDataTable,
    },
    data() {
        return {
            activeTabName: 'vd', // vd | os
            status: '',
            cat_sno: null,
            hasAdr: null,
            vendorSettings_OS: [],
            vendorSettings_VD: [],
            datas: [],
            currPage: 1,
            pageSize: 50,
            totalDataCount: 0,
            totalDataCount_vd: 0,
            totalDataCount_os: 0,
            searchTxt: '',
            errorMsg: '',
            OutsourcingBatchImportDialog: {
                visible: false,
                data: null,
            },
            vendorImportDialogVisible: false,
            personImportDialogVisible: false,
        };
    },
    mounted() {
        if (this.$route.query.typ === 'vd') this.activeTabName = 'vd';
        else if (this.$route.query.typ === 'os') this.activeTabName = 'os';

        this.updateData();
        this.fetchTotals();
        this.fetchTypeSettings();
    },
    computed: {
        typeList() {
            return this.activeTabName === 'vd' ? this.vendorSettings_VD : this.vendorSettings_OS;
        },
        tableColumns() {
            switch (this.activeTabName) {
            case 'os':
                return {
                    index: {
                        label: '#',
                        start: 1,
                    },
                    voo: {
                        label: '系統編號',
                        width: 100,
                    },
                    fnam: {
                        label: '名稱',
                        disableHide: true,
                        width: 180,
                    },
                    bsn: {
                        label: '證件號碼',
                        width: 160,
                    },
                    caT_NAM: {
                        label: '類型',
                        width: 180,
                    },
                    note: {
                        label: '備註',
                    },
                    adr: {
                        label: '地址',
                        clickable: false,
                    },
                };
            default:
                return {
                    index: {
                        label: '#',
                        start: 1,
                    },
                    voo: {
                        label: '系統編號',
                        width: 100,
                    },
                    fnam: {
                        label: '名稱',
                        disableHide: true,
                    },
                    bsn: {
                        label: '統編',
                        width: 120,
                    },
                    caT_NAM: {
                        label: '類型',
                        width: 180,
                    },
                    note: {
                        label: '備註',
                    },
                    adr: {
                        label: '地址',
                    },
                };
            }
        },
    },
    methods: {
        onUploadSheet() {
            this.OutsourcingBatchImportDialog.visible = true;
        },

        onOutsourcingBatchImportDialogClose(refresh) {
            this.OutsourcingBatchImportDialog.visible = false;
            if (refresh) this.updateData();
        },
        onVendorImportDialogClose(refresh) {
            this.vendorImportDialogVisible = false;
            if (refresh) this.updateData();
        },
        onPersonImportDialogClose(refresh) {
            this.personImportDialogVisible = false;
            if (refresh) this.updateData();
        },

        handleTypeChange() {
            this.$router.replace({ name: 'outsourcing', query: { typ: this.activeTabName } });
            this.cat_sno = null;
            this.updateData();
        },
        handleAddVdBtnClick() {
            this.$router.push({ name: 'outsourcing-add-company' });
        },
        handleAddOsBtnClick() {
            this.$router.push({ name: 'outsourcing-add-person' });
        },

        handleDataRowClick(data) {
            if (data.vdR_TYP === 'VD') {
                this.$router.push({ name: 'outsourcing-edit-company', params: { sno: data.sno } });
            } else if (data.vdR_TYP === 'OS') {
                this.$router.push({ name: 'outsourcing-edit-person', params: { sno: data.sno } });
            }
        },

        handleDetailDialogClose() {},

        handlePaginationChange() {
            this.updateData();
        },
        handleSearchEnter() {
            this.updateData();
        },
        handleSearchClear() {
            this.updateData();
        },

        updateData() {
            const type = this.activeTabName;
            this.status = 'loading';
            this.errorMsg = '';

            let url = `Outsourcing/GetOutsourcingList?VDR_TYP=${type}&PageSize=${this.pageSize}&PageNum=${this.currPage}`;

            if (this.searchTxt.trim() !== '') url += `&Keyword=${this.searchTxt}`;

            if (this.cat_sno !== null) url += `&CAT_SNO=${this.cat_sno}`;

            if (this.hasAdr !== null) url += `&HasAdr=${this.hasAdr}`;

            this.$api({
                url,
                method: 'GET',
            }).then((resp) => {
                this.status = 'success';
                this.datas = resp.data.items;
                this.totalDataCount = resp.data.totalNum;
            });
        },

        fetchTotals() {
            this.$api({
                url: 'Outsourcing/GetOutsourcingList?VDR_TYP=vd&PageSize=1&PageNum=1',
                method: 'GET',
            }).then((resp) => {
                this.totalDataCount_vd = resp.data.totalNum;
            });

            this.$api({
                url: 'Outsourcing/GetOutsourcingList?VDR_TYP=os&PageSize=1&PageNum=1',
                method: 'GET',
            }).then((resp) => {
                this.totalDataCount_os = resp.data.totalNum;
            });
        },
        fetchTypeSettings() {
            this.$api({
                url: '/Tool/GetDepartmentAndVendorSettings',
                method: 'get',
            }).then((resp) => {
                this.vendorSettings_OS = resp.data.vendorSettings_OS;
                this.vendorSettings_VD = resp.data.vendorSettings_VD;
            });
        },
        // colVisible(col) {
        //     return this.tableColumns.find((x) => x.label === col).visible;
        // },
        // toggleVoo() {
        //     const column = this.tableColumns.find((x) => x.label === 'voo');
        //     column.visible = !column.visible;
        // },
    },
};
</script>
<style lang="scss">
@import "@/assets/scss/vars.scss";

.oursourcing-page {
    .infos-tab {
        line-height: unset;
        margin: 10px 0;

        .el-tabs__header > .el-tabs__nav-wrap > .el-tabs__nav-scroll > .el-tabs__nav {
            .el-tabs__item {
                height: auto;
                line-height: unset;
                max-width: 330px;
                vertical-align: top;
                padding: 0 30px;

                .name {
                    font-size: 12pt;
                    font-weight: bold;
                }

                .description {
                    font-size: 9.5pt;
                    padding: 5px 0 20px 0;
                    white-space: pre-wrap;
                    line-height: 150%;
                }
            }
        }
    }
    .clickable-col-text {
        display: inline-block;
        cursor: pointer;

        &:hover {
            text-decoration: underline;
        }
    }
}
</style>
